export const getAuthToken = () =>
    sessionStorage.getItem('userToken') || localStorage.getItem('userToken')

export const persistAuthToken = (token) => {
    localStorage.removeItem('userToken')
    if (token) {
        sessionStorage.setItem('userToken', token)
    }
}

export const clearAuthToken = () => {
    sessionStorage.removeItem('userToken')
    localStorage.removeItem('userToken')
}

const isAuthenticate = () => getAuthToken()

export default isAuthenticate
